import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
import { useEffect, useState } from "react";

const StickyDownloadCTA = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling 300px
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-background/95 backdrop-blur border-t shadow-lg lg:hidden animate-slide-up">
      <Button 
        asChild
        size="lg"
        className="w-full bg-gradient-warm hover:shadow-hover transition-all duration-300 text-lg h-14"
      >
        <a
          href="https://pxa.receitasem30minutos.com.br/lt/ebook-acesso"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Download className="mr-2 h-5 w-5" />
          Baixar e-book
        </a>
      </Button>
    </div>
  );
};

export default StickyDownloadCTA;
